/**
 * Polyfill for browser: Node's `global` is not defined in browsers.
 * Some dependencies expect `global` to exist.
 */
declare const window: Window & { global?: typeof globalThis };
if (typeof window !== 'undefined' && typeof window.global === 'undefined') {
  window.global = window;
}

/**
 * Polyfill stable language features. These imports will be optimized by `@babel/preset-env`.
 *
 * See: https://github.com/zloirock/core-js#babel
 */
import "core-js/stable";
import "regenerator-runtime/runtime";
